
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/markets/[region]/[slug]",
      function () {
        return require("private-next-pages/markets/[region]/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/markets/[region]/[slug]"])
      });
    }
  